module.exports = __webpack_public_path__ + "img/logo-jira.cb154bf2.svg";